import quoteEvergreenBgWeb from "app/assets/quote_patterns/quote-evergreen-bg-web.png"
import quoteGeometricBgWeb from "app/assets/quote_patterns/quote-geometric-bg-web.png"
import quoteLeavesBgWeb from "app/assets/quote_patterns/quote-leaves-bg-web.png"
import quoteOceanBgWeb from "app/assets/quote_patterns/quote-ocean-bg-web.png"
import quoteWaveBgWeb from "app/assets/quote_patterns/quote-wave-bg-web.png"
import React from "react"
import { twMerge } from "tailwind-merge"

import AnimatedSection from "../../ProProfileShared/AnimatedSection"
import { DEFAULT_HIGHLIGHT_CLASSES } from "../WebsiteBuilderV2Page"

const QuoteSectionDesktop = ({ section, theme, highlightedField }) => {
  const isHighlighted = highlightedField === `section-${section.id}`
  const settings = section.settings || {}

  // Quote settings
  const quoteAuthor = settings.quoteAuthor || ""
  const rawPattern = (settings.backgroundPattern || "leaves").toLowerCase()
  const legacyToNew = { water: "ocean", pine: "evergreen", swoop: "wave" }
  const backgroundPattern = (legacyToNew[rawPattern] || rawPattern).toLowerCase()

  const palette = {
    textLight: theme?.colors?.textLight || "#FFFFFF",
    textDark: theme?.colors?.textDark || "#0b3954",
    primaryDark: theme?.colors?.primaryDark || "#8B6F6B",
    secondary: theme?.colors?.secondary || "#e9dfdc",
    bgDark: theme?.colors?.bgDark || "#efeae8"
  }

  // Get background pattern styles
  const getBackgroundPattern = () => {
    switch (backgroundPattern) {
      case "leaves":
        return { backgroundColor: palette.bgDark }
      case "ocean":
        return { backgroundColor: palette.bgDark }
      case "evergreen":
        return { backgroundColor: palette.bgDark }
      case "wave":
        return { backgroundColor: palette.bgDark }
      case "geometric":
        return { backgroundColor: palette.bgDark }
      default:
        return { backgroundColor: palette.bgDark }
    }
  }

  // Get background image for each pattern
  const getBackgroundImage = () => {
    switch (backgroundPattern) {
      case "leaves":
        return quoteLeavesBgWeb
      case "ocean":
        return quoteOceanBgWeb
      case "evergreen":
        return quoteEvergreenBgWeb
      case "wave":
        return quoteWaveBgWeb
      case "geometric":
        return quoteGeometricBgWeb
      default:
        return quoteLeavesBgWeb
    }
  }

  return (
    <section
      className={twMerge("relative overflow-hidden py-16 lg:py-24", isHighlighted ? DEFAULT_HIGHLIGHT_CLASSES : "")}
      style={{
        ...getBackgroundPattern(),
        width: "100vw"
      }}>
      {/* Background image from Figma design - preserving original transparencies */}
      <img
        src={getBackgroundImage()}
        alt=""
        aria-hidden
        className="pointer-events-none absolute inset-0 h-full w-full select-none bg-cover"
      />

      <AnimatedSection className="relative z-10 mx-auto max-w-6xl px-5 md:px-4">
        <div className="flex h-[276px] items-center justify-center text-center">
          <div className="max-w-4xl">
            {/* Quote Text */}
            <blockquote
              className="mb-6 text-[28px] font-medium leading-[32px] xl:text-4xl lg:text-5xl md:text-3xl md:leading-relaxed"
              style={{
                fontFamily: theme?.fonts?.heading || "serif",
                fontWeight: theme?.fonts?.headingWeight || "700",
                color: palette.textLight
              }}>
              &quot;{section.body || "Your quote text will appear here..."}&quot;
            </blockquote>

            {/* Quote Author */}
            {quoteAuthor && (
              <div
                className="text-[18px] font-semibold leading-[24px] lg:text-2xl md:text-xl"
                style={{
                  fontFamily: theme?.fonts?.paragraph || "sans-serif",
                  fontWeight: theme?.fonts?.paragraphRegularWeight || "400",
                  color: palette.textLight
                }}>
                — {quoteAuthor}
              </div>
            )}
          </div>
        </div>
      </AnimatedSection>
    </section>
  )
}

export default QuoteSectionDesktop
